import type { GachaResult } from '../stores/agentStore';
import { agentPortrait, typeAbbr, typeLabelCN, rarityLabel, rarityColor, typeBgColor } from '../utils/agent-ui-helpers';

interface SummonShowcaseProps {
  result: GachaResult;
  portraitUrl: string | null;
  wishText: string;
  onConfirm: () => void;
  confirmLabel?: string;
}

export function SummonShowcase({ result, portraitUrl, wishText, onConfirm, confirmLabel = '确认收下' }: SummonShowcaseProps) {
  const { agent, isNew } = result;
  const displayPortrait = portraitUrl || agentPortrait(agent.configId);

  return (
    <div className="summon-showcase">
      {/* 立绘区 */}
      <div className="summon-showcase__portrait-frame">
        <img
          className="summon-showcase__portrait-img"
          src={displayPortrait}
          alt={agent.name}
        />
        {isNew && <span className="summon-showcase__new-badge">NEW!</span>}
        {result.portraitStatus === 'generating' && (
          <div className="summon-showcase__generating">立绘生成中...</div>
        )}
      </div>

      {/* 信息卡 */}
      <div className="summon-showcase__info-card">
        <div className="summon-showcase__name">{agent.name.split('-')[0]}</div>
        <div className="summon-showcase__stars" style={{ color: rarityColor(agent.rarity) }}>
          {'★'.repeat(agent.rarity)} · {rarityLabel(agent.rarity)}
        </div>
        <div className="summon-showcase__type" style={{ color: typeBgColor(agent.type) }}>
          {typeAbbr(agent.type)} · {typeLabelCN(agent.type)}
        </div>
        {wishText && (
          <div className="summon-showcase__wish">"{wishText}"</div>
        )}
        <div className="summon-showcase__stats">
          <div>ATK <span className="summon-showcase__stat-val">{agent.attack}</span></div>
          <div>DEF <span className="summon-showcase__stat-val">{agent.defense}</span></div>
          <div>HP <span className="summon-showcase__stat-val">{agent.hp}</span></div>
        </div>
      </div>

      <button className="summon-overlay__confirm-btn" onClick={onConfirm}>
        {confirmLabel}
      </button>
    </div>
  );
}
